import { Toast } from 'antd-mobile';
import { CPInfo, closeReminder, CPRankList, weddingInfo, sendBless, floatingScreen } from '@/services/activity';

export default {
  namespace: 'springFestivalCP',
  state: {
    title: '',
    titleUrl: '',
    rules: '',
    rulesUrl: '',
    popTitle: '',
    popRules: '',
    hasCP: false,
    isShowRender: false,
    status: 0, // 活动状态 0未开始 1进行中 2已结束
    countDown: 0,
    cpExtraExperience: '',
    limitedGifts: [],
    daysInfo: [],
    currentDay: {},
    dailyRewards: [],
    totalRewards: [],
    weddingRewards: [],
    rewardsUrl: '',
    userIdA: '',
    userIdB: '',
    todayGift: {},
    extraScore: 0,
    self: {},
    ranks: {},
    hasMore: false,
    weddingStatus: 0,
    finalCPInfo: {},
    cpInfos: [],
    weddingBoatRewards: [],
    blessRewards: [],
    obtainedIds: [],
    blessCount: 0,
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        rulesUrl: payload.rulesUrl || '',
        popTitle: payload.popTitle || '',
        popRules: payload.popRules || '',
        hasCP: payload.hasCP,
        isShowRender: payload.isShowRender,
        status: payload.status || 0,
        countDown: payload.countDown || 0,
        cpExtraExperience: payload.cpExtraExperience || '',
        limitedGifts: payload.limitedGifts || [],
        daysInfo: payload.daysInfo || [],
        currentDay: payload.currentDay || {},
        dailyRewards: payload.dailyRewards || [],
        totalRewards: payload.totalRewards || [],
        weddingRewards: payload.weddingRewards || [],
        rewardsUrl: payload.rewardsUrl || '',
      };
    },
    updateCloseReminder(state, { payload }) {
      return {
        ...state,
        isShowRender: false,
      };
    },
    updateList(state, { payload }) {
      let lastUserA = '';
      let lastUserB = '';
      let list = payload.force ? [] : [...state.ranks];
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastUserA = payload.ranks[payload.ranks.length - 1].rankUserA.userId;
        lastUserB = payload.ranks[payload.ranks.length - 1].rankUserB ? payload.ranks[payload.ranks.length - 1].rankUserB.userId : '';
      }
      return {
        ...state,
        todayGift: payload.todayGift,
        extraScore: payload.extraScore,
        self: payload.self,
        ranks: list,
        userIdA: lastUserA,
        userIdB: lastUserB,
        // hasMore: payload.ranks.length < 99 ? false : true, 这里后端改了逻辑 无论怎么请求都是99条
      };
    },
    updateWeddingInfo(state, { payload }) {
      return {
        ...state,
        weddingStatus: payload.status,
        finalCPInfo: payload.finalCPInfo,
        cpInfos: payload.cpInfos,
        weddingBoatRewards: payload.weddingRewards,
        blessRewards: payload.blessRewards,
        blessCount: payload.blessCount,
      };
    },
    updateBless(state, { payload }) {
      return {
        ...state,
        obtainedIds: payload.obtainedIds,
        blessCount: payload.blessCount,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(CPInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getCloseReminder({ payload }, { call, put }) {
      const { error, data } = yield call(closeReminder, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateCloseReminder',
        payload: data,
      });
      return true;
    },
    *getList({ payload }, { call, put, select }) {
      const { userIdA, userIdB } = yield select(state => state.springFestivalCP);
      const { error, data } = yield call(CPRankList, { ...payload, userIdA: payload.force ? '' : userIdA, userIdB: payload.force ? '' : userIdB, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getWeddingInfo({ payload }, { call, put }) {
      const { error, data } = yield call(weddingInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateWeddingInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateWeddingInfo',
        payload: data,
      });
      return true;
    },
    *getFloatList({ payload }, { call }) {
      const { error, data } = yield call(floatingScreen, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return data.length ? data : [];
      } else {
        return false;
      }
    },
    *sendBlessToCP({ payload }, { call, put }) {
      const { error, data } = yield call(sendBless, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateBless',
        payload: data,
      });
      return true;
    },
  },
};
